import pako from 'pako';

/**
 * Represents optional guest, discount, and holder data to be encoded.
 * https://docs.liteapi.travel/docs/deeplinking-to-whitelabel#supported-xdata-fields
 */
export interface XDataInput {
  /**
   * Optional list of guests.
   */
  guests?: Array<{
    firstName?: string;
    lastName?: string;
    email?: string;
  }>;

  /**
   * Optional discount code.
   */
  discount?: {
    code?: string;
  };

  /**
   * Optional booking holder information.
   */
  holder?: {
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}

/**
 * Compresses and encodes booking data into a Base64-encoded gzipped string (`xData`).
 * This format is typically used for lightweight, URL-safe data transfer.
 *
 * https://docs.liteapi.travel/docs/deeplinking-to-whitelabel#supported-xdata-fields
 *
 * @param xData - The input data object to encode.
 * @returns A Base64 string representing the compressed data.
 *
 */
export const encodeXData = (xData?: XDataInput): string | undefined => {
  if (!xData) return;
  const json = JSON.stringify(xData);
  const compressed = pako.gzip(json);
  const base64 = Buffer.from(compressed).toString('base64');
  return base64;
};
